import styled, { css } from "styled-components";

const AccountSettingsContainer = styled.div`
    margin-bottom: 30px;
    margin-top: 33px;
    @media (min-width: 768px) {
        padding-left: 50px;
    }

    .lt-sec,
    .rt-sec {
        > .inner {
        }
    }

    ${(props) =>
        props.theme &&
        css`
            @media (min-width: ${props.theme.breakpoints.lg_min}px) {
                .lt-sec,
                .rt-sec {
                    > .inner {
                        max-width: 450px;
                    }
                }
            }
        `}

    .form-lt,
    .form-rt,
    .form-ct {
        margin-bottom: 20px;
    }
    .form-lt,
    .form-rt {
        width: 50%;
    }
    .form-ct {
        width: 100%;
    }
    .form-lt {
        padding-right: 10px;
    }
    .form-rt {
        padding-left: 10px;
    }

    .default-form-input {
        box-shadow: none !important;
        border-color: #333;
        &:focus {
            border-color: #000;
        }

        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        &[type="number"] {
            -moz-appearance: textfield;
        }
    }

    .form-item.has-error {
        > input,
        > select,
        > textarea {
            border-color: #dc3545;
        }
    }
    .form-item {
        input {
            padding-right: 35px;
        } 
        .icon {
            top: 33px;
            right: 10px;
            font-size: 18px;
        }
    }

    .default-btn {
        width: 100%;
        border: 2px solid #333;
        font-size: 13px;
        padding: 9px 12px;
        background-color: #333;
        color: #fff;
        height: 40px;
        &:hover {
            background-color: #000;
        }
    }
`;

export { AccountSettingsContainer };
